<!-- 意见反馈-结果 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">意见反馈</p>
		</div>

		<div class="module-wrap">

			<div class="module">
				<p class="module-title">
					反馈内容
					<span>(必填）</span>
				</p>
				<div class="textarea-box">
					<textarea class="textarea" v-model="params.content" rows="" placeholder="请输入你需要反馈的内容" cols=""></textarea>
				</div>
			</div>

			<div class="module">
				<p class="module-title">
					反馈说明
					<span>(必填）</span>
				</p>
				<div class="textarea-box" style="height: 140px;">
					<textarea class="textarea" v-model="params.desc" rows="" placeholder="请详细描述问题，以便于我们解决问题" cols=""></textarea>
				</div>
			</div>

		</div>

		<div class="btn-box">
			<button type="button" @click="submit()">提交</button>
		</div>


	</div>
</template>

<script>
	import {UserManageService} from "@/common/service";
  import {validatorFun} from "@/common/util";
  import {Toast} from "vant";

  export default {
		components: {},
		data() {
			return {
        params: {
          content: '',  // 反馈内容
          desc: '',  // 反馈说明
        },
			};
		},
		mounted() {},
		methods: {
      submit() {
        const params = this.params;
        const errList = validatorFun(params, [
          ['content', ['notNull', '请输入你需要反馈的内容']],
          ['desc', ['notNull', '请详细描述问题，以便于我们解决问题']],
        ]);
        if (errList.length > 0) {
          return Toast(errList[0].errMsg);
        }
        UserManageService.leaveFeedback(params).then(() => {
          this.$router.replace('/feedback-result');
        });
      }
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F3F3F3;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 56px 15px 15px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.icon {
		width: 48px;
		margin: 40px 0 15px;
	}

	.font-1 {
		color: #2A63F3;
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 45px;
	}

	.font-2 {
		color: #222222;
		font-size: 14px;
		margin-bottom: 7px;
	}

	.btn-box {
		width: 100%;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.btn-box>button {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
		background-color: #2A63F3;
		border-radius: 100px;
		width: 100%;
		height: 46px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 52px 0;
	}

	.module-wrap {
		width: 100%;
		background-color: #ffffff;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
	}

	.module {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 10px 22px;
		box-sizing: border-box;
	}

	.module-title {
		width: 100%;
		height: 49px;
		line-height: 49px;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 15px;
		font-weight: 500;
	}

	.module-title>span {
		font-weight: normal;
		margin-left: 6px;
		color: #2A63F3;
		font-size: 12px;
	}

	.textarea-box {
		width: 100%;
		height: 100px;
		padding: 12px 10px;
		box-sizing: border-box;
		border-radius: 14px;
		background-color: #F3F3F3;
	}

	.textarea {
		width: 100%;
		height: 100%;
		font-size: 10px;
	}

	.textarea::placeholder {
		color: #999999;
	}
</style>
